import NoActivityImage from 'src/shared/features/users/assets/empty/man.png'

import EmptyView from './empty-view'

const NoActivity = ({ firstName }: { firstName: string }) => {
  return (
    <EmptyView
      description="A quick post on the feed is a great way to show some personality"
      image={<img src={NoActivityImage} className="translate-y-12 rotate-[20deg] scale-150" />}
      title={`${firstName} hasn't posted anything yet.`}
    />
  )
}

export default NoActivity
